module.exports = __webpack_public_path__ + "static/img/view7-3.539213c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view7-3.png
// module id = Bfq4
// module chunks = 1